import React, { useCallback } from 'react';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import * as Styles from './FreeDomainStep.styles';
import {
  Checkbox, Skeleton, TextField, Tag,
} from 'gatorcomponents';
import DOMPurify from 'dompurify';
import NavBar from '@/media/onboarding/navbar.svg';
import { domainsActions } from '@/redux/modules';
import { useDispatch } from 'react-redux';
import { STEPS } from '../../DomainRegisterHandler.enum';

const FreeDomainStep = ({
  locales,
  buttonsProps,
  domainSld,
  handleRedeemDomain,
  loadingRedeem,
  currentRadix,
  loadingDomainAvailability,
  currentStep,
  tld,
  setCheckedRadixOption,
  checkedRadixOption,
  setUserClickedContinue,
}) => {
  const dispatch = useDispatch();

  const stepIndex = currentStep === STEPS.FREE_DOMAIN_ONLINE ? 0 : 1;
  const currentRadixCheckedOption = checkedRadixOption && checkedRadixOption[stepIndex] ? checkedRadixOption[stepIndex].refuse : false;

  const hasRadixError = !loadingRedeem && !loadingDomainAvailability && currentRadix.domain && !currentRadix.isAvailable;

  const mountRadixLabel = () => (
    <Styles.TagLabel>
      {tld}
      <Tag label={locales.freeTag} variant="info" size="sm" />
    </Styles.TagLabel>
  );

  const genericStepProps = useCallback(() => {
    const rightButtonCta = () => {
      setUserClickedContinue(true);

      if (currentRadixCheckedOption) {
        return handleRedeemDomain({ redeemRadix: false });
      }

      return dispatch(domainsActions.domainAvailability.request({
        sld: domainSld,
        tld: tld.slice(1),
        isRadix: true,
      }));
    };

    const customButtonsProps = {
      ...buttonsProps,
      rightButton: {
        ...buttonsProps.rightButton,
        onClick: rightButtonCta,
        disabled: loadingDomainAvailability || loadingRedeem,
      },
    };

    return {
      icon: null,
      title: null,
      description: null,
      imageSrc: null,
      testId: 'plan-turno-free-domain-step',
      buttonsProps: customButtonsProps,
    };
  }, [
    buttonsProps,
    dispatch,
    domainSld,
    tld,
    loadingDomainAvailability,
    loadingRedeem,
    handleRedeemDomain,
    currentRadixCheckedOption,
    setUserClickedContinue,
  ]);

  return (
    <GenericStep {...genericStepProps()} contentWidthFlexible>
      <Styles.Wrapper>
        <Styles.Title dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(locales.title) }} />
        <Styles.Description dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(locales.description) }} />
        <Styles.Subtitle dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(locales.subtitle) }} />

        <Styles.NavWrapper>
          <Styles.NavbarContainer>
            <Styles.NavbarImage src={NavBar} />
          </Styles.NavbarContainer>
          <Styles.DomainInputWrapper>
            <Styles.DomainFieldsContainer>
              <Styles.TextFieldContainer>
                {loadingRedeem && (
                  <Skeleton width="100%" height="56px" />
                )}
                {!loadingRedeem && (
                  <TextField
                    testId="input-sld"
                    label=""
                    value={domainSld}
                    disabled
                  />
                )}
              </Styles.TextFieldContainer>
              <Styles.SelectFieldContainer>
                {loadingRedeem && (
                  <Skeleton width="100%" height="56px" />
                )}
                {!loadingRedeem && mountRadixLabel()}
              </Styles.SelectFieldContainer>
            </Styles.DomainFieldsContainer>
          </Styles.DomainInputWrapper>

        </Styles.NavWrapper>
        {hasRadixError && (
          <Styles.ErrorText>
            {locales.radixUnavailable[tld.slice(1)](currentRadix.domain)}
          </Styles.ErrorText>
        )}

        <Styles.CheckboxLabel
          htmlFor="refuse-radix"
          data-testid="check-agreement-label"
          onClick={() => {
            if (loadingRedeem || loadingDomainAvailability) return;
            const newCheckedRadixOption = [...(checkedRadixOption || [{ refuse: false }, { refuse: false }])];
            newCheckedRadixOption[stepIndex] = {
              refuse: !currentRadixCheckedOption,
            };
            setCheckedRadixOption(newCheckedRadixOption);
            setUserClickedContinue(false);
          }}
        >
          <Checkbox
            checked={
              currentRadixCheckedOption
            }
            id="refuse-radix"
          />
          <Styles.CheckboxDescription>
            {locales.refuseRadix}
          </Styles.CheckboxDescription>
        </Styles.CheckboxLabel>
        <Styles.Disclaimer>
          {locales.disclaimer}
        </Styles.Disclaimer>
      </Styles.Wrapper>
    </GenericStep>
  );
};

export default FreeDomainStep;
